export default __webpack_public_path__ + "static/tannpuss-2-74f2ee1b549f5a40b4282bdb3859dcaf.png";